import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../molecules/RoundedModal'
import CodeTag from '../../../../../atoms/CodeTag'

const DelegationConfirmationDialog = React.forwardRef(function DelegationConfirmationDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (connectionRequestId) => setDialogState({ open: true, connectionRequestId })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Confirmation'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <div>
            <div className='flex flex-row justify-between mb-2'>
              <span>Use the following link to have the admin enter their credentials</span><span>(Click below to copy)</span>
            </div>
            <CodeTag
              className='font-size-sm p-sm clickable' onClick={() => {
                try {
                  navigator.clipboard.writeText(`${window.location.origin}/admin/requests/item/${dialogState.connectionRequestId}`)
                } catch (error) {
                  console.error(error)
                }
              }}
            >
              {window.location.origin}/admin/requests/item/{dialogState.connectionRequestId}
            </CodeTag>
          </div>
        ) : null}
      </div>
    </RoundedModal>
  )
})

DelegationConfirmationDialog.propTypes = {
}

DelegationConfirmationDialog.defaultProps = {
  onComplete: () => {}
}

export default DelegationConfirmationDialog
